import script from "./AvatarConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarConfig.vue?vue&type=script&setup=true&lang=js"

import "./AvatarConfig.vue?vue&type=style&index=0&id=2744aec6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2744aec6"]])

export default __exports__